import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { SWRConfig } from 'swr';
import axios from 'axios';
import { AuthProvider } from 'react-auth-kit';
import { ContextProvider } from './context/GlobalContext';
import App from './App';
import LoadingPanel from './components/common/LoadingPanel';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SWRConfig
    value={{
      fetcher: (...args) => axios.get(...args).then((res) => res.data),
      suspense: true,
    }}
  >
    <Suspense height="100%" fallback={<LoadingPanel />}>
      <Router>
        <AuthProvider authType="sessionStorage" authName="_auth">
          <ContextProvider>
            <App />
          </ContextProvider>
        </AuthProvider>
      </Router>
    </Suspense>
  </SWRConfig>
);
